import './autocomplete.css';

import { SearchProvider } from '@diamond/shared/context';
import {
  AdminCaptureMeta,
  captureAdminApiError,
  isAdminSentryCaptured,
} from '@diamond/shared/utils';
import { AuthProvider } from '@diamond/sol-admin/features/auth';
import { AppRoutes } from '@diamond/sol-admin/routes';
import { CookieUniversalProvider } from '@shopify/react-cookie';
import {
  MutationCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: {
      adminCapture?: AdminCaptureMeta;
    };
  }
}

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      const adminCapture = mutation.meta?.adminCapture;
      if (!adminCapture) {
        return;
      }
      if (isAdminSentryCaptured(error)) {
        return;
      }

      captureAdminApiError({
        error,
        requestPath: adminCapture.requestPath,
        httpMethod: adminCapture.httpMethod,
        queryKey: adminCapture.queryKey,
        operation: adminCapture.operation,
        feature: adminCapture.feature,
        queryParams: adminCapture.queryParams,
      });
    },
  }),
});

function App() {
  return (
    <CookieUniversalProvider>
      <QueryClientProvider client={queryClient}>
        <SearchProvider>
          <BrowserRouter>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </BrowserRouter>
        </SearchProvider>

        <ReactQueryDevtools
          initialIsOpen={false}
          position="right"
          buttonPosition="bottom-right"
        />
      </QueryClientProvider>
    </CookieUniversalProvider>
  );
}

export default App;
